// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".favorites-button[data-v-5a0f5678]{display:flex;align-items:center;grid-column-gap:10px;-moz-column-gap:10px;column-gap:10px;background:none;outline:none;border:none;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;cursor:pointer;color:#2d2e2a}.favorites-button--active[data-v-5a0f5678]{color:#653932}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
